module.exports = __webpack_public_path__ + "static/media/gear.78b0f9d0.svg";